import { ChangeLogAction, ChangeLogCategory, ChangeLogSubCategory } from "@/graphql/codegen/graphql"

export const CHANGE_LOG_SEARCH_PLACEHOLDER = "Search by Category, Sub-Category, Record or User Name"

export const CHANGE_LOG_CATEGORY_LABELS: Record<ChangeLogCategory, string> = {
  [ChangeLogCategory.Admin]: "Admin",
  [ChangeLogCategory.Company]: "Company",
  [ChangeLogCategory.Dashboard]: "Dashboard",
  [ChangeLogCategory.ProductAll]: "Product (All)",
  [ChangeLogCategory.ProductSupplier]: "Product (Supplier)",
  [ChangeLogCategory.PurchaseOrderAndQuote]: "Purchase Order And Quote",
  [ChangeLogCategory.SalesOrder]: "Sales Order",
  [ChangeLogCategory.User]: "User",
}

export const CHANGE_LOG_SUB_CATEGORY_LABELS: Record<ChangeLogSubCategory, string> = {
  [ChangeLogSubCategory.Accounting]: "Accounting",
  [ChangeLogSubCategory.Comments]: "Comments",
  [ChangeLogSubCategory.Contacts]: "Contacts",
  [ChangeLogSubCategory.Documents]: "Documents",
  [ChangeLogSubCategory.General]: "General",
  [ChangeLogSubCategory.Locations]: "Locations",
  [ChangeLogSubCategory.Pricing]: "Pricing",
  [ChangeLogSubCategory.Products]: "Products",
  [ChangeLogSubCategory.QualityApprovals]: "Quality Approvals",
  [ChangeLogSubCategory.Regulatory]: "Regulatory",
  [ChangeLogSubCategory.TestResults]: "Test Results",
  [ChangeLogSubCategory.TestTemplates]: "Test Templates",
  [ChangeLogSubCategory.EquivalentGroups]: "Equivalent Groups",
  [ChangeLogSubCategory.GlAccounts]: "GL Accounts",
  [ChangeLogSubCategory.None]: "N/A",
}

export const CHANGE_LOG_ACTION_LABEL_LOOKUP: Record<ChangeLogAction, string> = {
  [ChangeLogAction.Activated]: "Activated",
  [ChangeLogAction.Added]: "Added",
  [ChangeLogAction.Archived]: "Archived",
  [ChangeLogAction.Created]: "Created",
  [ChangeLogAction.Deactivated]: "Deactivated",
  [ChangeLogAction.Deleted]: "Deleted",
  [ChangeLogAction.Edited]: "Edited",
  [ChangeLogAction.Published]: "Published",
  [ChangeLogAction.Unarchived]: "Unarchived",
}
